 <template>
    <el-dialog :visible.sync="visible" width="600px" append-to-body title="编辑联系人" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <el-form :model="form" size="mini" label-position="top" v-loading="loading">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="姓名" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                        <el-input v-model="form.name" placeholder="请填写联系人名称" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="负责人" :rules="[{ required: true, message: '必填项' }]" :error="formError.user_admin_id?.toString()" prop="user_admin_id">
                        <users-select v-model="form.user_admin_id" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="客户名称" :rules="[{ required: true, message: '必选项' }]" :error="formError.customer_id?.toString()" prop="customer_id">
                        <crm-customer-select v-model="form.customer_id" clearable @onChange="CustomerOnChange" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="手机">
                        <el-input v-model="form.phone" placeholder="请填写联系人工作电话" prefix-icon="el-icon-mobile" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="电话">
                        <el-input v-model="form.phone_t" placeholder="请填写联系人工作电话" prefix-icon="el-icon-phone-outline" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱">
                        <el-input v-model="form.email" placeholder="电子邮件地址" prefix-icon="el-icon-message" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="性别">
                        <el-select v-model="form.sex" placeholder="请选择" :style="{ width: '100%' }" clearable>
                            <el-option value="女" label="女" />
                            <el-option value="男" label="男" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否关键决策人">
                        <el-select v-model="form.policymakers" placeholder="请选择" :style="{ width: '100%' }" clearable>
                            <el-option value="是" label="是" />
                            <el-option value="否" label="否" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="所在部门">
                        <el-input v-model="form.department" placeholder="联系人所在部门" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="职务">
                        <el-input v-model="form.appointment" placeholder="联系人的职务信息或职务名称" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider content-position="left">联系地址</el-divider>
            <el-row :gutter="5">
                <el-col :span="8">
                    <el-form-item>
                        <config-country-select v-model="form.country" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                        <config-country-select-province v-model="form.country_province" :country="form.country" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                        <config-country-select-city v-model="form.country_province_city" :province="form.country_province" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-input type="textarea" :rows="2" v-model="form.address" placeholder="详细地址" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
            loading: false,
            formError: {},
            form: {
                id: null,
                name: null,
                user_admin_id: null,
                customer_id: null,
                phone: null,
                phone_t: null,
                email: null,
                sex: null,
                policymakers: '否',
                department: null,
                appointment: null,
                country: null,
                country_province: null,
                country_province_city: null,
                address: null,
            }
        }
    },
    methods: {
        Open (id) {
            this.visible = true
            this.loading = true
            this.$http.post('/9api/crm/contacts/search-first', { search: { id: id } }).then(rps => {
                this.form = rps.data
                this.loading = false
            })
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        CustomerOnChange(data) {
            if (data) {
                this.form.country = data.country
                this.form.country_province = data.country_province
                this.form.country_province_city = data.country_province_city
                this.form.address = data.address
            }
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}
                        this.$http.post('/9api/crm/contacts/update', this.form).then(rps => {
                                this.loading = false
                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>